import React, { useMemo } from 'react'
import BotaoCTA from '../..//BotaoCTA'
import Slider from 'react-styled-carousel'
import { DotBlueGray } from '../../../layouts/Default'
import CardTemplateSelector from '../../Cards/CardTemplateSelector'
import { useMedia } from 'use-media'
import {
    ContainerList,
    LeftArrow,
    RightArrow,
    Imagem1,
    Imagem2,
    InnerContainerListaPassoAPasso,
} from '../styles'

const MultipleCards = ({
    id,
    tamanhoListaCards,
    botaoEmbaixo,
    imagem,
    imagemAux,
    isZoom,
    responsive,
    listaDeCards,
    botao,
}) => {
    const isMobile = useMedia({
        maxWidth: 768,
    })
    // Seta o mesmo tamanho para todos os cards
    // setTimeout(() => {
    //     let height

    //     document.querySelectorAll(`.card-list-item${id}`).forEach((item) => {
    //         if (!height || item.childNodes[0].clientHeight > height) {
    //             height = item.childNodes[0].clientHeight
    //         }
    //     })

    //     document.querySelectorAll(`.card-list-item${id}`).forEach((item) => {
    //         item.childNodes[0].setAttribute('style', `height: calc(${height}px + 5px)`)
    //     })
    // })

    const lista = useMemo(() => {
        return listaDeCards.map((item) => (
            <div className={`card-list-item${id}`} key={item.name}>
                <CardTemplateSelector card={item} />
            </div>
        ))
    }, [id, listaDeCards])

    return (
        <ContainerList
            tamanhoListaCards={tamanhoListaCards}
            botaoEmbaixo={botaoEmbaixo}
        >
            <InnerContainerListaPassoAPasso>
                {imagem && !isZoom && <Imagem1 src={imagem} />}
                {imagemAux && !isZoom && <Imagem2 src={imagemAux} />}
                <Slider
                    draggable={false}
                    showArrows
                    showDots={isMobile}
                    autoSlide={false}
                    responsive={responsive}
                    ssr
                    infinite={false}
                    autoPlay={false}
                    Dot={<DotBlueGray />}
                    keyBoardControl
                    LeftArrow={<LeftArrow />}
                    RightArrow={<RightArrow />}
                    padding="0"
                >
                    {lista}
                </Slider>
            </InnerContainerListaPassoAPasso>
            {botao && <BotaoCTA botao={botao} botaoEmbaixo={botaoEmbaixo} />}
        </ContainerList>
    )
}
export default MultipleCards
